import { useState } from 'react'
import Header from '../../../../customs/Header'
import MembershipRouteContent from './MembershipRouteContent';
import CreateRouteContent from './CreateRouteContent';
import SettingsModal from '../Modal/settingsCustomModal';

const Main = () =>{
  const [openCreateModal, setOpenCreateModal] = useState(false);

  const handleOpenCreateModal = () => setOpenCreateModal(true);
  const handleCloseCreateModal = () => setOpenCreateModal(false);

  return (
    <section>
      <Header props={
        {
          firstName: "All",
          secondName: "Membership Route",
          buttonText: "Create Route"
        }} 
        handleOpen = {handleOpenCreateModal}
      />
      <MembershipRouteContent />
        <SettingsModal 
          open={openCreateModal}
          cancel={handleCloseCreateModal}
          maxWidth="480px"
          header={"Create Route"}
          showrightIcon={false}
          content={<CreateRouteContent handleClose={handleCloseCreateModal}/>}
        />
    </section>
  )
}

export default Main;
